import { Button } from "../../button/Button";
import { ButtonProps } from "../../button/ButtonProps";
import { Table } from "../Table";

export abstract class AbstractTableHeadingButton {
    protected button: Button;
    protected buttonProps: Partial<ButtonProps>;
    protected readonly table: Table;

    constructor(table: Table, props?: Partial<ButtonProps>) {
        this.table = table;
        this.buttonProps = props;
        this.create();
    }

    get(): Button {
        return this.button;
    }

    rowSelectionChanged() {
    }

    protected create() {
        this.button = new Button({ ...this.buttonProps });
        delete this.buttonProps;
    }
}
